import React from "react";

import Svg from "@/styles/Svg";
import { isTouchDevice } from "@/utils/getters";

import Counter from "./Counter";
import {
  Circle,
  CounterWrapper,
  IconWrapper,
  InnerCircle,
  MoreInfo,
  ResultCircle,
  ResultWrapper,
  Share,
  Text,
  Water,
} from "./styles";

export enum ResultType {
  percent = "percent",
  count = "count",
}

export enum SharingType {
  x = "x",
  whatsApp = "whatsapp",
  facebook = "facebook",
}

export type ResultGlassProps = {
  type: ResultType;
  icons: IIcons;
  resultText?: string;
  userVoteCount: number;
  totalVoteCount: number;
  showDetails: boolean;
  onShareClick: (type: SharingType) => void;
};

export type ResultGlassState = {
  animation: boolean;
};

export default class ResultGlass extends React.Component<
  ResultGlassProps,
  ResultGlassState
> {
  public constructor(props: ResultGlassProps) {
    super(props);
    this.state = { animation: false };
  }

  public componentDidMount(): void {
    // Get another keyframe
    setTimeout(() => this.setState({ animation: true }), 1000);
  }

  public render(): JSX.Element {
    const { animation } = this.state;
    const {
      icons,
      resultText,
      userVoteCount,
      totalVoteCount,
      showDetails,
      onShareClick,
    } = this.props;
    const percent = Math.round((userVoteCount / totalVoteCount) * 100);

    return (
      <Circle>
        <InnerCircle>
          <Water percent={animation ? percent : 0} />
          {animation && (
            <ResultWrapper>
              <ResultCircle>
                {this.renderCount()}
                <MoreInfo>
                  {showDetails && (
                    <Text>
                      <span>{userVoteCount.toLocaleString()}</span> von{" "}
                      <span>{totalVoteCount.toLocaleString()}</span>
                    </Text>
                  )}
                  {resultText && <Text>{resultText}</Text>}
                  <Share>
                    <IconWrapper
                      onClick={() => onShareClick(SharingType.facebook)}
                    >
                      <Svg contents={icons.Facebook} height={20} width={25} />
                    </IconWrapper>
                    <IconWrapper onClick={() => onShareClick(SharingType.x)}>
                      <Svg contents={icons.X} height={22} width={22} />
                    </IconWrapper>
                    {isTouchDevice() && (
                      <IconWrapper
                        onClick={() => onShareClick(SharingType.whatsApp)}
                      >
                        <Svg contents={icons.WhatsApp} height={22} width={22} />
                      </IconWrapper>
                    )}
                  </Share>
                </MoreInfo>
              </ResultCircle>
            </ResultWrapper>
          )}
        </InnerCircle>
      </Circle>
    );
  }

  private renderCount(): JSX.Element {
    const { animation } = this.state;
    const { type, userVoteCount, totalVoteCount } = this.props;
    const percent = Math.round((userVoteCount / totalVoteCount) * 100);

    if (type === ResultType.count) {
      return (
        <React.Fragment>
          {animation && (
            <CounterWrapper>
              <h1>
                {userVoteCount} / {totalVoteCount}
              </h1>
            </CounterWrapper>
          )}
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          {animation && (
            <CounterWrapper>
              <Counter start={0} end={percent} duration={2000}>
                {(value: number) => <span>{value || 0}%</span>}
              </Counter>
            </CounterWrapper>
          )}
        </React.Fragment>
      );
    }
  }
}
